import { createFileRoute } from '@tanstack/react-router'
import { ResellerPage, RESELLER_CONTENT } from '../components/ResellerPage'
import { getStorefrontConfig } from '../lib/dropify'
import { absoluteUrl, brandTitle, buildFaqSchema, DEFAULT_OG_IMAGE } from '../lib/seo'

export const Route = createFileRoute('/cara-jadi-reseller')({
  loader: async () => ({
    config: await getStorefrontConfig().catch(() => null),
  }),
  head: () => {
    const title = brandTitle(RESELLER_CONTENT.seoTitle)
    const description = RESELLER_CONTENT.seoDescription

    return {
      meta: [
        { title },
        { name: 'description', content: description },
        { name: 'robots', content: 'index, follow' },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: absoluteUrl('/cara-jadi-reseller') },
        { property: 'og:image', content: DEFAULT_OG_IMAGE },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: DEFAULT_OG_IMAGE },
      ],
      links: [{ rel: 'canonical', href: absoluteUrl('/cara-jadi-reseller') }],
      scripts: [
        {
          type: 'application/ld+json',
          children: JSON.stringify(buildFaqSchema(RESELLER_CONTENT.faq)),
        },
      ],
    }
  },
  component: CaraJadiResellerPage,
})

function CaraJadiResellerPage() {
  const { config } = Route.useLoaderData()
  return <ResellerPage config={config} content={RESELLER_CONTENT} />
}
